import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';

export const Route = createFileRoute('/_app/')({
    beforeLoad: ({ location }) => authoriseUser(Object.values(ROLES), location),
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    component: () => <Main />,
});

const Main = () => {
    const { t } = useTranslation();
    return (
        <section className="page">
            <section className="content pt-4">
                <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    <span>{t('PAGES.MAIN')}</span>
                </div>
            </section>
        </section>
    );
};
